<template>
  <div class="p-relative">
    <v-toolbar
      class="d-sm-none"
      color="transparent"
      tag="nav"
      width="100%"
      elevation="0"
      absolute
      dense
    >
      <v-btn class="white" icon elevation="0" small @click="$router.go(-1)">
        <v-icon color="black" small>$chevron_left</v-icon>
      </v-btn>
      <v-spacer />
      <!-- <v-btn class="white" icon elevation="0" small>
        <v-icon color="black" small>$share</v-icon>
      </v-btn> -->
      <!-- <v-btn class="white ml-3" icon elevation="0" small>
        <v-icon color="black" small>far fa-heart</v-icon>
      </v-btn> -->
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: "listing-toolbar",
};
</script>

<style scoped></style>
